import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const togglees = document.querySelectorAll(`[data-input-checkbox-togglee="${event.currentTarget.id}"]`)
    togglees.forEach((element) => element.classList.toggle("hidden"))
  }
}
